import { __awaiter } from "tslib";
import { BehaviorSubject } from 'rxjs';
import { Themes } from '@ids/tokens';
/**
 * Objeto contendo todos os segmentos.
 *
 * @category Segment
 */
export const Segments = Object.keys(Themes).reduce((segments, token) => (Object.assign(Object.assign({}, segments), { [token]: token.toLocaleLowerCase() })), {});
const _segment = new BehaviorSubject('Varejo');
// TO-DO: mater comentado e substituir pela cdn
// const _segmentTokens = new BehaviorSubject<{ [key in string]: string }>(Varejo);
const getKeySegment = (value) => Object.keys(Segments).find((key) => Segments[key] === value);
/**
 * Observable do nome do Segmento.
 *
 * @category Segment
 */
export const Segment = _segment.asObservable();
// TO-DO: mater comentado e substituir pela cdn
// /**
//  * Observable de tokens por segmento.
//  *
//  * @category Segment
//  */
// export const SegmentTokens = _segmentTokens.asObservable();
/**
 * Envia novo valor de Segmento para os subscribers e para o elemento raiz da aplicação.
 *
 * @param value Novo valor de Segmento
 * @param document documento dom
 *
 * @category Segment
 *
 * @example
 * ```ts
 * import { changeSegment, Segments } from '@ids/tools';
 *
 * changeSegment(Segments.Uniclass);
 * ```
 */
export const changeSegment = (value = Segments.Varejo, currentDocument = document) => __awaiter(void 0, void 0, void 0, function* () {
    _segment.next(getKeySegment(value));
    const classes = [];
    // TO-DO: mater comentado e substituir pela cdn
    // const newTheme = await import(`@ids/tokens/${value}/tokens`);
    // _segmentTokens.next(newTheme);
    currentDocument.documentElement.classList.forEach((className) => {
        if (className.startsWith('voxel-theme') || className.startsWith('ids-theme')) {
            classes.push(className);
        }
    });
    if (classes.length > 0) {
        currentDocument.documentElement.classList.remove(...classes);
    }
    currentDocument.documentElement.classList.add(`ids-theme-${value}`);
});
//# sourceMappingURL=segment.js.map